import clsx from 'clsx';
import React, { forwardRef } from 'react';

export type CheckboxProps = {
  label?: React.ReactNode;
  ariaLabelledby?: string;
  cn?: string;
  partial?: boolean;
  labelClassName?: string;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      partial,
      labelClassName = '',
      style = {},
      cn,
      className,
      ariaLabelledby,
      ...rest
    },
    ref,
  ) => {
    const inputbox = (
      <input
        aria-labelledby={ariaLabelledby}
        type="checkbox"
        ref={ref}
        style={{ width: '20px', height: '20px', ...style }}
        // Using @tailwind/forms base class to allow styling the default input
        className={clsx('form-checkbox', cn, className)}
        {...rest}
      />
    );

    // Firefox will read the aria-label twice if a label is present. By removing the label if
    // it's falsy, we can sometimes avoid this issue.
    return label ? (
      <label
        className={`relative flex cursor-pointer items-center gap-3 ${labelClassName}`}
      >
        {inputbox}
        {label}
      </label>
    ) : (
      <span
        className={`relative flex cursor-pointer items-center gap-3 ${labelClassName}`}
      >
        {inputbox}
      </span>
    );
  },
);

Checkbox.displayName = 'Checkbox';
